import React, { useCallback, useContext, useState } from 'react';
import { Button, message } from 'antd';
import dayjs from 'dayjs';

import TicketContext from '@totem/components/ticketing/details/ticketContext';
import BulkTimeEntryContext from '@totem/components/ticketing/details/timeEntry/bulkTimeEntry/bulkTimeEntryContext';
import {
  TimeEntryBulkCreateRequest,
  TimeEntryBulkStatus,
} from '@totem/components/ticketing/details/timeEntry/bulkTimeEntry/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { isNotNull } from '@totem/utilities/common';
import { TICKET_ENDPOINT } from '@totem/utilities/endpoints';
const BulkTImeSubmitButton = () => {
  const { userProfile, getApiToken } = useContext(UserProfileContext);
  const { ticket, onAction } = useContext(TicketContext);
  const { timeEntryCommon, taskTimeItems, onUpdateTaskHours } =
    useContext(BulkTimeEntryContext);
  const [isSending, setSending] = useState<boolean>(false);
  const timeEntryDate = dayjs(timeEntryCommon.date);
  const itemsWithHours = taskTimeItems.filter(
    (item) => item.timeEntry.hoursLogged > 0,
  );
  const isValid =
    isNotNull(timeEntryCommon.resourceId) &&
    timeEntryCommon.resourceId !== '' &&
    timeEntryDate.year() > 2000 &&
    itemsWithHours.length > 0;
  const sendTimeEntry = useCallback(
    async (paramTicketId: string, payload: TimeEntryBulkCreateRequest) => {
      if (!isSending) {
        setSending(true);

        fetch(`${TICKET_ENDPOINT}/${paramTicketId}/timeTrackingBulk`, {
          method: 'POST',
          headers: new Headers({
            Authorization: `Bearer ${getApiToken()}`,
          }),
          body: JSON.stringify(payload),
        })
          .then((response) => {
            if (response.status === 200) {
              return response.json();
            }
            message.error('ERROR: Creating Time Entries');
            return response.json();
          })
          .then((result: TimeEntryBulkStatus[]) => {
            let hasFailures = 0;
            result.forEach((item) => {
              if (item.success) {
                onUpdateTaskHours(item.taskId, 0);
              } else {
                hasFailures++;
              }
            });
            if (hasFailures === 0) {
              onAction('refresh', '');
            }
          })
          .finally(() => {
            setSending(false);
          });
      }
    },
    [],
  );
  const onSubmit = () => {
    const payload: TimeEntryBulkCreateRequest = {
      common: {
        resourceId: timeEntryCommon.resourceId,
        date: timeEntryCommon.date,
        billingId: '',
        createdByType: 'USER',
        createdByName: userProfile.email,
        createdById: userProfile.id,
        createdAt: dayjs().toISOString(),
        isDeleted: false,
      },
      items: itemsWithHours.map((item) => {
        return {
          taskId: item.id,
          ...item.timeEntry,
        };
      }),
    };
    sendTimeEntry(ticket.ticket.id, payload);
  };
  return (
    <Button
      disabled={!isValid}
      type="primary"
      htmlType="submit"
      onClick={() => onSubmit()}
    >
      Submit Time Entries
    </Button>
  );
};
export default BulkTImeSubmitButton;
